import type { Action } from "../pages";

export interface ComponentProps {
  metadata: {
    name: string;
    variant?: string;
  };
  props?: unknown;
  actions?: Action[];
}

export interface componentExistsProps {
  name: string;
  components: ComponentProps[];
}

export interface getPropsByNameProps {
  name: string;
  components: ComponentProps[] | undefined;
}

export const componentExists = ({ name, components }: componentExistsProps) =>
  components?.some(component => component?.metadata.name === name);

export const getPropsByName = (props: getPropsByNameProps) => {
  const { name, components } = props;

  const componentEntry = components?.find(
    component => component?.metadata.name === name,
  );

  if (!componentEntry) {
    return null;
  }

  // Pass metadata to the component as props
  const featureProps = {
    ...((componentEntry?.props || {}) as Record<string, unknown>),
    ...{ componentName: componentEntry?.metadata.name },
    ...{ variant: componentEntry?.metadata.variant },
  };

  // NOTE: actions are not currently used
  return componentEntry?.actions
    ? { ...featureProps, actions: componentEntry?.actions }
    : featureProps;
};
